import { FACEBOOK } from '../../data/scrapecreators/facebook';
import { GOOGLE } from '../../data/scrapecreators/google';
import { INSTAGRAM } from '../../data/scrapecreators/instagram';
import { LINKEDIN } from '../../data/scrapecreators/linkedin';
import { REDDIT } from '../../data/scrapecreators/reddit';
import { TIKTOK } from '../../data/scrapecreators/tiktok';
import { TWITTER } from '../../data/scrapecreators/twitter';
import { YOUTUBE } from '../../data/scrapecreators/youtube';
import { WEB } from '../../data/web';
import type { EditorialApiDetail } from '../../data/editorial';
import {
  liveActionOf,
  liveApiDetail,
  mergeLiveEndpoints,
  type RawCatalogEntry,
} from '../../lib/catalogMap';
import { platformIdOf } from '../../lib/catalogPlatform';
import type { ApiDetail } from './model';

/** Authored catalog records contain presentation and documentation facts only. */
export const EDITORIAL_DETAILS: Readonly<Record<string, EditorialApiDetail>> = {
  reddit: REDDIT,
  tiktok: TIKTOK,
  instagram: INSTAGRAM,
  youtube: YOUTUBE,
  'x-twitter': TWITTER,
  facebook: FACEBOOK,
  linkedin: LINKEDIN,
  google: GOOGLE,
  web: WEB,
};

/** Proves every published authored endpoint has a matching live SKU. */
export const validateCatalogAuthority = (entries: RawCatalogEntry[]): void => {
  for (const [routeId, detail] of Object.entries(EDITORIAL_DETAILS)) {
    mergeLiveEndpoints(detail, entries, routeId);
  }
};

/** The detail a platform page shows: its authored copy merged with live facts,
 *  or the live projection alone for a platform with no authored copy. */
export const catalogDetail = (
  entries: RawCatalogEntry[],
  routeId: string,
): ApiDetail | null => {
  const editorial = EDITORIAL_DETAILS[routeId];
  return editorial
    ? mergeLiveEndpoints(editorial, entries, routeId)
    : liveApiDetail(entries, routeId);
};

/** The English action title a SKU's endpoint page shows: its authored action,
 *  or the live one read off the slug, as `catalogDetail` resolves it. */
export const endpointActionOf = (slug: string): string =>
  EDITORIAL_DETAILS[platformIdOf(slug)]?.endpoints.find((endpoint) => endpoint.sku === slug)?.action ??
  liveActionOf(slug);
